import { ArrowBack as IconArrowBack } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { MapPanelHeader } from "~/modules/map/components/MapPanel";

interface WeatherReportsHeaderProps {
    backHref: string;
}

export function WeatherReportsHeader({ backHref }: WeatherReportsHeaderProps) {
    const { t } = useTranslation("project");

    return (
        <MapPanelHeader>
            <IconButton component={Link} color="inherit" to={backHref}>
                <IconArrowBack />
            </IconButton>

            <Stack paddingBlock={1} flexGrow={1}>
                <Typography variant="h6">{t("projectReviewVisitV2.weatherReportsRoute.title")}</Typography>
            </Stack>
        </MapPanelHeader>
    );
}
